import * as React from 'react';
import { cn } from '@noor/lib/cn';

export type AppShellSecondaryNavProps = Omit<React.ComponentProps<'nav'>, 'children'> & {
  /** Optional heading/title rendered above the nav items. */
  header?: React.ReactNode;
  /** The nav rows — typically `SidebarNavItem`s. */
  children?: React.ReactNode;
};

function AppShellSecondaryNav({
  className,
  header,
  children,
  ...props
}: AppShellSecondaryNavProps) {
  return (
    <nav
      data-slot="app-shell-secondary-nav"
      className={cn(
        'flex h-full w-[220px] shrink-0 flex-col gap-1 border-r border-border bg-card p-3',
        className,
      )}
      {...props}
    >
      {header !== undefined ? (
        <div data-slot="app-shell-secondary-nav-header" className="px-1 pb-2">
          {header}
        </div>
      ) : null}
      {children}
    </nav>
  );
}

export { AppShellSecondaryNav };
